const Functions = []

const uniqueItemsReducer = (acc, item) => {
    // Verifica si el item ya está en el acumulador basado en productId
    if (!acc.some(existingItem => existingItem.productId === item.productId)) {
        acc.push(item);
    }
    return acc;
};

// Función para filtrar duplicados en un array de items
const removeDuplicates = (itemsArray) => {
    return itemsArray.reduce(uniqueItemsReducer, []);
};


const formatNumber = (value,maxDigits = 0, minimumDigits = 0) => {
    if (value === null || value === undefined || value === '-') return '-';

    const num = Number(value);
    if (isNaN(num)) return '-';

    const truncatedNum = Math.trunc(num);
    return new Intl.NumberFormat('es-AR', {
        maximumFractionDigits: maxDigits,
        minimumFractionDigits: minimumDigits
    }).format(truncatedNum);
};

export { removeDuplicates, formatNumber }



